import { useMemo } from 'react';

import { Theme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';

import Profile from './Profile';
import Localization from './Localization';
import StreamNotification from './StreamNotification';
import MegaMenuSection from './MegaMenuSection';
import ImpersonationBanner from './ImpersonationBanner';
import AiChatTrigger from './AiChatTrigger';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

import { MenuOrientation } from 'types/config';
import StreamChannels from './StreamChannels';

const HeaderContent = () => {
  const { i18n, menuOrientation } = useConfig();
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const localization = useMemo(() => <Localization />, [i18n]);

  const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      <Box sx={{ width: '100%', ml: 1 }} />
      <ImpersonationBanner />
      <StreamNotification />
      <StreamChannels />
      <AiChatTrigger />
      <Profile />
    </>
  );
};

export default HeaderContent;
